import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { db } from '../firebase/Firebase'
import ColType from '../Types'
//import PersonAvatar from '../customcomponents/PersonAvatar'
//import Empty from '../customcomponents/Empty'
import { flattenDoc, formatNumberWithCommas, getStateStandardNamesDict } from '.././Util'
import BoxPlot from './BoxPlot'
import LineChart from './LineChart'
import { Radio, Icon, Layout } from 'antd'
import Empty from '../customcomponents/Empty'
import PersonAvatar from '../customcomponents/PersonAvatar'
import DistrictStatsV3 from './DistrictStatsV3'
import DistrictStatsV4 from './DistrictStatsV4'
import CustomFooter from '../login/CustomFooter'
import QuizStats from './QuizStats'
//import { Row } from 'antd'
//import { Select } from 'antd'
//var moment = require('moment')
const Content = Layout.Content

class AdminDistrictStats extends Component {
    state = {
    }

    render() {
        // Determine which district ID to use
        const districtId = this.props.adminBaseProps?.district?.id ||
            this.props.instructionalFacilitatorBaseProps?.district?.id;

        // Use V4 only for demo district, V3 for everyone else
        const isDemoDistrict = districtId && districtId.startsWith('demo_b8afbef6f77b');
        const DistrictStatsComponent = isDemoDistrict ? DistrictStatsV4 : DistrictStatsV3;

        return <div>
            <div>
                <Layout className="content relative">
                    <Layout>
                        <Content className='layout-header-mt'>
                            <div>
                                <div>
                                    <div className="pl-4 pr-4 mt-3">
                                        {this.props.adminBaseProps && this.props.adminBaseProps.district ?
                                            <div>
                                                <QuizStats {...this.props} />
                                                {/*!isDemoDistrict ?
                                                    <DistrictStatsComponent {...this.props} /> : ''*/}
                                            </div>
                                            :
                                            this.props.instructionalFacilitatorBaseProps &&
                                                this.props.instructionalFacilitatorBaseProps.district &&
                                                this.props.instructionalFacilitatorBaseProps.schools &&
                                                this.props.instructionalFacilitatorBaseProps.schoolsDict ?
                                                <div>
                                                    <QuizStats {...this.props} />
                                                    {/*!isDemoDistrict ?
                                                        <DistrictStatsComponent {...this.props} /> : ''*/}
                                                </div>
                                                : ""}
                                    </div>
                                </div>
                            </div>
                        </Content>
                    </Layout>
                </Layout>
            </div>
            <CustomFooter />
        </div>
    }
}

export default AdminDistrictStats
